import { jsxs, jsx } from 'react/jsx-runtime';
import { AnnouncementPrimitive } from '../announcement-primitive/announcement-primitive.js';
import { useValidatedContext } from '../hooks/use-validated-context.js';
import { useMessagePrefix } from './banner.utils.js';
import { BannerContext } from './banner-context.js';
import { srOnly } from '../styles/composables.css.js';
import { message, messageTitle } from './banner.css.js';

/**
 * Text to be displayed inside of Banner
 *
 * @compose {}
 */
function Message({ title, children, ...props }) {
    const { variant } = useValidatedContext(BannerContext, 'Banner.Message', 'Banner');
    const messagePrefix = useMessagePrefix(variant);
    return (jsxs(AnnouncementPrimitive, { "data-fpl-component": "", ...props, className: message, role: variant === 'danger' ? 'alert' : 'status', children: [messagePrefix && jsxs("span", { className: srOnly, children: [messagePrefix, "\u00A0"] }), title && jsx("span", { className: messageTitle, children: title }), jsx("span", { children: children })] }));
}
Message.displayName = 'Banner.Message';

export { Message };
//# sourceMappingURL=banner-message.js.map
